module.exports = __webpack_public_path__ + "img/GH-corporate-top-logo.8833644c.png";